import { useState, useEffect } from "react"
import QuillEditor from "./QuillEditor.js"
import TextInput from "../components/TextInput.js"
import styles from "../components/PageEdit.module.css"
import SelectImage from "../components/SelectImage.js"
import Profil from "../components/websiteComponents/Profil.js"
import AuthorDropDown from "../util/author-drop-down.js"
import { fetchAuthor } from "../util/fetch-author.js"
import { saveAuthor } from "../util/save-author.js"

export default function EditAuthor({author_id, onAuthorChange}){
        const [authorData, setAuthorData] = useState(null);
        const [name,setName] = useState("");
        const [bio, setBio] = useState("");
        const [image, setImage] = useState(null);
        const [modal, setModal] = useState(false);

        useEffect(() => {
            console.log(author_id)
            if (author_id === undefined || author_id === null) return;
            fetchAuthor(author_id, setAuthorData);
        }, [author_id]);
        useEffect(() => {
            if (authorData) {
            setName(authorData.name || "");
            setBio(authorData.bio || "");
            setImage(authorData.image || null);
            }
        }, [authorData]);

        const handleSave = async () => {
            const data = { name, bio, image };
            await saveAuthor(author_id, data, (newId) => {
                onAuthorChange(newId);
            });
            toggleModal();
        };

        const toggleModal = () => {
            setModal(true)
            setTimeout(() => {
                setModal(false);
            }, 5000);
    }
        
        return(
            <div className={styles.pageInfoEdit}>

                <p style={{marginTop:'30px'}}>Vælg mellem allerede oprettede forfattere</p>
                <AuthorDropDown onSelectAuthor={(newId) => onAuthorChange(newId)}/>

                <p style={{marginTop:'30px'}}>Eller redigere i den eksterende/ opret en ny forfatter</p>

                <TextInput
                    label={"Navn:"}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <QuillEditor

                    theme="snow"
                    value={bio}
                    onChange={(value) => setBio(value)}
                    placeholder="Skriv noget om forfatteren her..."
                />

                <div>
                    <Profil image={image}/>
                    <SelectImage onSelect={(url) => setImage(url)}/>
                </div>
                
                
                <button className={styles.bnt} onClick={handleSave}>Gem forfatteren</button>

                {modal && 
                    <div className={styles.modal}>
                        <p>Forfatter gemt</p>
                    </div>}
            </div>
            );
    }